import ChevronLeft from '@mui/icons-material/ChevronLeft'
import ChevronRight from '@mui/icons-material/ChevronRight'
import provider_unavailable from '~/assets/images/provider_unavailable.svg'
import { Chip, IconButton } from '@mui/material'
import { format } from 'date-fns'
import { ISO_DATE_FORMAT } from '~/shared/lib/date'
import { addDays, isBefore, isSameDay, startOfDay, startOfWeek } from 'date-fns'
import { FC, useState } from 'react'
import { getDateTime } from '../utils'

type WeekChipsProps = {
  value: Date
  now: Date
  onChange: (date: Date) => void
  setDateForMonth: (value: Date) => void
  datesWithSlotAvailability: string[]
  maxDate?: Date
}
const ProviderUnavailableIcon = (
  <img
    src={provider_unavailable}
    alt="ProviderUnavailable"
    style={{ position: 'absolute', top: -5, right: 5 }}
  />
)

const WeekChips: FC<WeekChipsProps> = ({
  value,
  onChange,
  now,
  setDateForMonth,
  datesWithSlotAvailability,
  maxDate,
}) => {
  const [sow, setSow] = useState(startOfWeek(value))
  const startOfToday = startOfDay(now)
  const previousSow = addDays(sow, -7)

  return (
    <>
      <IconButton
        onClick={() => {
          setSow(previousSow)
          setDateForMonth(getDateTime(previousSow, now))
        }}
        disabled={isBefore(previousSow, startOfWeek(now))}
        sx={{
          padding: 0,
        }}
      >
        <ChevronLeft />
      </IconButton>
      {[0, 1, 2, 3, 4, 5, 6].map(days => {
        const date = addDays(sow, days)
        const disabled = isBefore(date, startOfToday) || (maxDate && isBefore(maxDate, date))

        return (
          <Chip
            disabled={disabled}
            icon={
              datesWithSlotAvailability.length
                ? datesWithSlotAvailability.find(
                    availableDate => availableDate === format(date, ISO_DATE_FORMAT),
                  )
                  ? undefined
                  : ProviderUnavailableIcon
                : ProviderUnavailableIcon
            }
            key={date.toDateString()}
            label={date.toLocaleDateString(undefined, { weekday: 'short', day: 'numeric' })}
            onClick={() => onChange(date)}
            color={isSameDay(value, date) ? 'primary' : 'default'}
            variant="outlined"
            sx={{
              width: '12%',
              minHeight: '35px',
              borderRadius: '24px',
              padding: 0,
              '&.MuiButtonBase-root.Mui-disabled': {
                backgroundColor: 'transparent',
              },
              '&.MuiButtonBase-root.MuiChip-colorPrimary': {
                backgroundColor: 'navy.500',
                color: 'common.white',
                borderColor: 'navy.500',
              },
              '&.MuiButtonBase-root.MuiChip-colorDefault': {
                backgroundColor: 'transparent',
                '&&:hover': {
                  backgroundColor: 'action.hover',
                },
              },
            }}
          />
        )
      })}
      <IconButton
        onClick={() => {
          const nextSow = addDays(sow, 7)
          setSow(nextSow)
          setDateForMonth(getDateTime(nextSow, now))
        }}
        disabled={maxDate && isBefore(maxDate, addDays(sow, 7))}
        sx={{
          padding: 0,
        }}
      >
        <ChevronRight />
      </IconButton>
    </>
  )
}

export default WeekChips
